import { objToUrlParams } from '@/utils'
import request from '@/utils/request'

// 结算订单列表接口
export const getOrderList = (params: any) => request({
    url: '/manage/settlement-order',
    method: 'get',
    params
})

// 结算订单详情
export const getOrderInfo = (params: any) => request({
    url: '/manage/settlement-order/' + params.ordernumber,
    method: 'get',
    params
})

// 修改结算订单状态
export const setOrder = (data: any) => request({
    url: '/manage//settlement-order/' + data.ordernumber + '/change/status',
    method: 'put',
    data
})

// 结算订单导出
export const orderExport = (data: any) => request({
    url: '/manage/settlement-order-export' + objToUrlParams(data),
    method: 'post'
})
// 修改成功代付订单状态
export const setSuccessStatus = (data: any) => request({
    url: '/manage/success-settlement-order/' + data.ordernumber + '/change/status',
    method: 'put',
    data
})

// 修改驳回结算订单接口
export const settsettlementReject = (data: any) => request({
    url: '/manage/settlement-order/' + data.ordernumber + '/regret',
    method: 'put',
    data
})